import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

export const getDcsPublicationState = (state) => state.dcsPublication;

export const getDcsPublication = createSelector(
  [getDcsPublicationState],
  (s) => s.getIn(['publication', 'data']) || null
);

export const getDcsPublicationLoading = createSelector(
  [getDcsPublicationState],
  (s) => s.getIn(['publication', 'loading']) || false
);

/** The points already published, in generated-address order. */
export const getDcsPoints = createSelector(
  [getDcsPublicationState],
  (s) => s.getIn(['publication', 'data', 'points']) || List()
);

/**
 * What the selected devices can publish, merged across their device factories by the API so the
 * UI holds no second copy of the catalogue.
 */
export const getDcsDataPoints = createSelector(
  [getDcsPublicationState],
  (s) => s.getIn(['dataPoints', 'data']) || Map()
);

export const getDcsMap = createSelector(
  [getDcsPublicationState],
  (s) => s.getIn(['map', 'data']) || Map()
);
